<template>
  <div class="space-y-6">
    <h3 class="text-xl font-bold text-gray-900 pb-2 border-b border-gray-100">
      Order Info
    </h3>
    <div
      v-if="hasStoreInfo"
      class="bg-gray-50 p-5 rounded-2xl border border-gray-100 space-y-3"
    >
      <div>
        <span class="text-xs text-gray-500 uppercase font-bold block mb-1">
          Store
        </span>
        <p v-if="storeDisplayName" class="font-bold text-base text-gray-900">
          {{ storeDisplayName }}
        </p>
      </div>

      <div
        v-if="storeAddress"
        class="flex items-start gap-2 text-sm text-gray-700"
      >
        <MapPin :size="16" class="text-gray-400 mt-0.5 flex-shrink-0" />
        <span>{{ storeAddress }}</span>
      </div>

      <div
        v-if="storePhone"
        class="flex items-center gap-2 text-sm text-gray-700"
      >
        <Phone :size="16" class="text-gray-400 flex-shrink-0" />
        <span>{{ storePhone }}</span>
      </div>
    </div>
    <OrderType
      v-if="!hideOrderType"
      :errors="errors"
      :grand-total="grandTotal"
    />
    <OrderSummary
      v-if="cartItems && cartItems.length > 0"
      :cart-items="cartItems"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MapPin, Phone } from "lucide-vue";
import OrderSummary from "./OrderSummary.vue";
import OrderType from "./OrderType.vue";
import { formatLocationAddress } from "@/utils/formatters";

export default {
  name: "CheckoutOrderInfoSection",
  props: {
    errors: {
      type: Object,
      default: () => {}
    },
    cartItems: {
      type: Array,
      default: () => []
    },
    grandTotal: {
      type: Number,
      default: 0
    },
    hideOrderType: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MapPin,
    OrderSummary,
    OrderType,
    Phone
  },
  computed: {
    ...mapGetters(["getStore", "selectedLocation"]),
    storeInfo() {
      return this.selectedLocation || this.getStore || {};
    },
    storeDisplayName() {
      const location = this.selectedLocation || {};
      const store = this.getStore || {};

      return (
        location.displayName ||
        location.display_name ||
        location.displayname ||
        location.location_name ||
        store.displayName ||
        store.display_name ||
        store.displayname ||
        store.location_name ||
        store.name ||
        ""
      );
    },
    storeAddress() {
      return formatLocationAddress(this.storeInfo);
    },
    storePhone() {
      return this.storeInfo.phone || this.getStore?.phone || "";
    },
    hasStoreInfo() {
      return !!(this.storeDisplayName || this.storeAddress || this.storePhone);
    }
  }
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
